function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { checkboxTheme } from "./chunk-XHYVH6UO.mjs";
import { runIfFn } from "./chunk-UV3F75RF.mjs"; // src/components/radio.ts

import { radioAnatomy as parts } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers, defineStyle } from "@chakra-ui/styled-system";

var _createMultiStyleConf = createMultiStyleConfigHelpers(parts.keys),
    defineMultiStyleConfig = _createMultiStyleConf.defineMultiStyleConfig,
    definePartsStyle = _createMultiStyleConf.definePartsStyle;

var baseStyleControl = defineStyle(function (props) {
  var _a;

  var controlStyle = (_a = runIfFn(checkboxTheme.baseStyle, props)) == null ? void 0 : _a.control;
  return _objectSpread(_objectSpread({}, controlStyle), {}, {
    borderRadius: "full",
    _checked: _objectSpread(_objectSpread({}, controlStyle == null ? void 0 : controlStyle["_checked"]), {}, {
      _before: {
        content: "\"\"",
        display: "inline-block",
        pos: "relative",
        w: "50%",
        h: "50%",
        borderRadius: "50%",
        bg: "currentColor"
      }
    })
  });
});
var baseStyle = definePartsStyle(function (props) {
  var _a, _b, _c, _d;

  return {
    label: (_b = (_a = checkboxTheme).baseStyle) == null ? void 0 : _b.call(_a, props).label,
    container: (_d = (_c = checkboxTheme).baseStyle) == null ? void 0 : _d.call(_c, props).container,
    control: baseStyleControl(props)
  };
});
var sizes = {
  md: definePartsStyle({
    control: {
      w: "4",
      h: "4"
    },
    label: {
      fontSize: "md"
    }
  }),
  lg: definePartsStyle({
    control: {
      w: "5",
      h: "5"
    },
    label: {
      fontSize: "lg"
    }
  }),
  sm: definePartsStyle({
    control: {
      width: "3",
      height: "3"
    },
    label: {
      fontSize: "sm"
    }
  })
};
var radioTheme = defineMultiStyleConfig({
  baseStyle: baseStyle,
  sizes: sizes,
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
});
export { radioTheme };